import * as _ from "lodash-es";
import React, { ChangeEvent, Component } from "react";
import Modal from "react-modal";
import CreateOrderComponentEnum from "../../../../models/CreateOrderComponentEnum";
import ICreateOrderDTO from "../../../../models/DTO/ICreateOrderDTO";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetAllSupplierTokensDTO from "../../../../models/DTO/IGetAllSupplierTokensDTO";
import IGetCatalogsDTO from "../../../../models/DTO/IGetCatalogsDTO";
import IGetCategoriesDTO from "../../../../models/DTO/IGetCategoriesDTO";
import IGetProjectsForVendorDTO from "../../../../models/DTO/IGetProjectsForVendorDTO";
import IGetProjectsDTO from "../../../../models/DTO/IGetProjectsDTO";
import IOnGetProjectsDTO from "../../../../models/DTO/IOnGetProjectsDTO";
import IGetVendorsDTO from "../../../../models/DTO/IGetVendorsDTO";
import IGetWarehousesDTO from "../../../../models/DTO/IGetWarehousesDTO";
import IOnCreateOrderDTO from "../../../../models/DTO/IOnCreateOrderDTO";
import IOnCreateVendorDTO from "../../../../models/DTO/IOnCreateVendorDTO";
import IOnGetCatalogsDTO from "../../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetCategoriesDTO from "../../../../models/DTO/IOnGetCategoriesDTO";
import IOnGetPriceGroupsDTO from "../../../../models/DTO/IOnGetPriceGroupsDTO";
import IOnGetProjectsForVendorDTO from "../../../../models/DTO/IOnGetProjectsForVendorDTO";
import IOnGetVendorsDTO from "../../../../models/DTO/IOnGetVendorsDTO";
import IOnGetWarehousesDTO from "../../../../models/DTO/IOnGetWarehousesDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import { getCapturedUtm } from "../../../../utils/UtmCapture";
import ICatalog from "../../../../models/ICatalog";
import ICategory from "../../../../models/ICategory";
import INotification from "../../../../models/INotification";
import IPrice_Group from "../../../../models/IPrice_Group";
import IProject from "../../../../models/IProject";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import IVendorModel from "../../../../models/IVendorModel";
import IWarehouse from "../../../../models/IWarehouse";
import UserTypesEnum from "../../../../models/UserTypesEnum";
import IdbService from "../../../../services/IdbService";
import systemConst from "../../../../services/SystemConst";
import OwButton from "../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import Typeahead from "../../../shared/Typeahead/Typeahead";
import { TypeaheadFn } from "../../../shared/TypeaheadFn/TypeaheadFn";
import "./CreateOrderSidebar.scss";
import OrderCategorySelector from "./OrderCategorySelector/OrderCategorySelector";
import IOrderGetTemplatesForAccountDTO from "../../../../models/DTO/IOrderGetTemplatesForAccountDTO";
import IOrderOnGetTemplatesForAccountDTO from "../../../../models/DTO/IOrderOnGetTemplatesForAccountDTO";
import IOrder from "../../../../models/IOrder";
import VendorSidebar from "../../../accounts/SupplierVendors/VendorSidebar/VendorSidebar";
import IWorkflow from "../../../../models/IWorkflow";
import IOnGetWorkflowsDTO from "../../../../models/DTO/IOnGetWorkflowsDTO";
import IGetWorkflowsDTO from "../../../../models/DTO/IGetWorkflowsDTO";
import { Socket } from "socket.io-client";
import IQBDShipMethodOption from "../../../../models/QuickBooks Desktop/IQBDShipMethodOption";
import OrderEntryService from "../../../../services/OrderEntryService";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import ITag from "../../../../models/ITag";
import IGetTagsDTO from "../../../../models/DTO/IGetTagsDTO";
import IOnGetTagsDTO from "../../../../models/DTO/IOnGetTagsDTO";
import IProcessTagDTO from "../../../../models/DTO/IProcessTagDTO";
import IOnProcessTagDTO from "../../../../models/DTO/IOnProcessTagDTO";
import OwDateInput from "@components/shared/OwDateInput/OwDateInput";
import { Moment } from "moment";

type Props = {
    history: any;
    cancelFn: () => void;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    vendorModel: IVendorModel;
    isQuote?: boolean;
    isTemplate?: boolean;
    isOnline: boolean;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
};

type State = {
    clearVendorTypeahead: boolean;
    foundVendors: IVendorModel[];
    selectedVendor?: IVendorModel | null;
    catalogs: ICatalog[];
    selectedCatalog?: ICatalog;
    priceGroups: IPrice_Group[];
    createOrderActive: boolean;
    hasCatalogLock: boolean;
    hasPriceGroupLock: boolean;
    lockedCatalogName: string;
    lockedPriceGroupName: string;
    isConnected: boolean;
    catalog?: number | null;
    price_group?: number | null;
    po_no?: string;
    description?: string;
    is_sample?: boolean;
    isValidCategorySelection?: boolean;
    category_id?: number;
    formValid: boolean;
    isOnline: boolean;
    projects?: IProject[];
    foundProjects?: IProject[];
    selectedProject?: IProject | null;
    project_id?: number | null;
    orderCategories?: ICategory[];
    orderCategoryActive: boolean;
    order_category_id?: number;
    modalIsOpen: boolean;
    modalComponent: any;
    warehouses: IWarehouse[];
    shipping_warehouse_id?: number;
    workflow_id?: number | null;
    is_local_delivery: boolean;
    is_local_pickup: boolean;
    is_dropship: boolean;
    is_consignment: boolean;
    allow_substitutions?: boolean;
    allow_backorders?: boolean;
    templates: Partial<IOrder[]>;
    template_id?: number | null;
    workflowOptions: IWorkflow[];
    qbd_ship_via?: IQBDShipMethodOption;
    filterInactive: boolean;
    is_noninventory_order?: boolean;
    is_default_template?: boolean;
    exchange_rate?: string;
    foundTags: ITag[];
    selectedTags: ITag[];
    selectedTag?: ITag;
    resetTagTypeahead: boolean;
    do_not_ship_before_date?: string;
};

class CreateOrderSidebar extends Component<Props, State> {
    formEl = React.createRef<HTMLFormElement>();

    idbService: IdbService = new IdbService();

    readonly state: State = {
        clearVendorTypeahead: false,
        foundVendors: [],
        selectedVendor: null,
        catalogs: [],
        priceGroups: [],
        createOrderActive: false,
        hasCatalogLock: false,
        hasPriceGroupLock: false,
        lockedCatalogName: "",
        lockedPriceGroupName: "",
        isConnected: false,
        formValid: false,
        price_group: null,
        catalog: null,
        isOnline: this.props.isOnline,
        project_id: null,
        orderCategories: [],
        orderCategoryActive: false,
        modalIsOpen: false,
        modalComponent: null,
        warehouses: [],
        is_local_delivery: false,
        is_local_pickup: false,
        is_dropship: false,
        is_consignment: false,
        templates: [],
        template_id: null,
        workflowOptions: [],
        workflow_id: this.props.supplierModel.has_multi_workflows ? this.props.supplierModel.default_workflow_id : undefined,
        filterInactive: true,
        is_noninventory_order: false,
        is_default_template: false,
        foundTags: [],
        selectedTags: [],
        resetTagTypeahead: false,
    };

    sockets: IUiSocketSetup[] = [];

    constructor(props: any) {
        super(props);

        this.sockets = [
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
            { endpoint: EndpointsEnum.VendorsOnGetVendors, fn: this.onGetVendors },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogs, fn: this.onGetCatalogs },
            { endpoint: EndpointsEnum.CatalogsOnGetPriceGroups, fn: this.onGetPriceGroups },
            { endpoint: EndpointsEnum.ProjectsOnGetProjectsForVendor, fn: this.onGetProjectsForVendor },
            { endpoint: EndpointsEnum.ProjectsOnGetProjects, fn: this.onGetProjects },
            { endpoint: EndpointsEnum.CategoriesOnGetCategories, fn: this.onGetCategories },
            { endpoint: EndpointsEnum.VendorsOnCreateVendor, fn: this.onCreateVendor },
            { endpoint: EndpointsEnum.WarehouseOnGetWarehouses, fn: this.onGetWarehouses },
            { endpoint: EndpointsEnum.OrderOnGetTemplatesForAccount, fn: this.onGetTemplatesByAccount },
            { endpoint: EndpointsEnum.WorkflowsOnGetWorkflows, fn: this.onGetWorkflows },
            { endpoint: EndpointsEnum.TagsOnGetTags, fn: this.onGetTags },
            { endpoint: EndpointsEnum.TagsOnProcessTag, fn: this.onProcessTag },
        ];
    }

    async componentDidMount() {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        if (this.state.isOnline) {
            if (!this.props.supplierModel.create_order_component) {
                if (this.props.userModel.isSupplierUser) {
                    // this.getSupplierTokens();

                    if (this.props.supplierModel.has_multi_workflows) {
                        this.getWorkflows();
                    }
                }

                if (this.props.supplierModel.has_order_categories) {
                    this.getCategories();
                }

                if (this.props.supplierModel.has_warehouses) {
                    this.getWarehouses();
                }

                this.getCatalogs();
            }
        }

        const state: any = {
            isConnected: true,
        };

        if (!this.state.isOnline) {
            state.catalogs = await this.idbService.getCatalogs();
        }

        if (!this.props.userModel.isSupplierUser) {
            state.selectedVendor = this.props.vendorModel;

            state.order_category_id = this.props.vendorModel.default_order_category_id;
        }

        this.setState(state);
    }

    componentWillUnmount() {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
    }

    notify = (data: IErrorDTO) => {
        this.setState({
            createOrderActive: false,
        });
    };

    getCategories = () => {
        const payload: IGetCategoriesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            onlyRootCategories: true,
            isOrderCategory: true,
        };

        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.vendorModel.guid;
        }

        this.props.socket.emit(EndpointsEnum.CategoriesGetCategories, payload);

        this.setState({
            orderCategoryActive: true,
        });
    };

    onCreateVendor = (data: IOnCreateVendorDTO) => {
        this.setState({
            modalComponent: null,
            modalIsOpen: false,
            selectedVendor: data.vendorModel,
            foundVendors: [],
        });
    };

    onGetCategories = (data: IOnGetCategoriesDTO) => {
        const categories = data.categories.filter((category) => !category.hide_category);
        this.setState({
            orderCategories: categories,
            orderCategoryActive: false,
        });
    };

    getTags = (name: string) => {
        const payload: IGetTagsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name,
        };

        this.props.socket.emit(EndpointsEnum.TagsGetTags, payload);
    };

    onGetTags = (data: IOnGetTagsDTO) => {
        this.setState({
            foundTags: data.tags,
        });
    };

    processTag = (name?: string) => {
        const payload: IProcessTagDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            tag: {
                name: name || "",
                supplier_id: this.props.supplierModel.id,
                is_order_tag: true,
            },
        };

        this.props.socket.emit(EndpointsEnum.TagsProcessTag, payload);
    };

    onProcessTag = (data: IOnProcessTagDTO) => {
        if (data.tag) {
            this.setState({
                selectedTags: [...this.state.selectedTags, data.tag],
                selectedTag: undefined,
                foundTags: [],
                resetTagTypeahead: true,
            });
        }
    };

    getWarehouses = () => {
        if (this.props.userModel.isSupplierUser || this.props.supplierModel.allow_accounts_select_warehouse) {
            const payload: IGetWarehousesDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
            };

            if (!this.props.userModel.isSupplierUser) {
                payload.vendorGuid = this.props.vendorModel.guid;
            }

            this.props.socket.emit(EndpointsEnum.WarehouseGetWarehouses, payload);
        } else {
            return null;
        }
    };

    onGetWarehouses = (data: IOnGetWarehousesDTO) => {
        this.setState({
            warehouses: data.warehouses.filter((warehouse) => !warehouse.is_hidden),
        });
    };

    getCatalogs = () => {
        const data: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            onlyActive: true,
            callMeta: {
                view: "CreateOrderSidebar",
                fn: "getCatalogs",
            },
        };

        if (!this.props.userModel.isSupplierUser) {
            data.vendorGuid = this.props.vendorModel.guid;
        }

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, data);
    };

    getSupplierTokens = () => {
        const data: IGetAllSupplierTokensDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.TokenGetAllSupplierTokens, data);
    };

    getTemplatesByAccount = () => {
        if (!this.state.selectedVendor) {
            return null;
        }

        const payload: IOrderGetTemplatesForAccountDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.state.selectedVendor.guid,
        };

        this.props.socket.emit(EndpointsEnum.OrderGetTemplatesForAccount, payload);
    };

    onGetTemplatesByAccount = (data: IOrderOnGetTemplatesForAccountDTO) => {
        if (data.orders) {
            this.setState({
                templates: data.orders,
            });
        }
    };

    getWorkflows = () => {
        const payload: IGetWorkflowsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.WorkflowsGetWorkflows, payload);
    };

    onGetWorkflows = (data: IOnGetWorkflowsDTO) => {
        this.setState({
            workflowOptions: data.workflows,
        });
    };

    getProjectsByVendor = () => {
        if (!this.state.selectedVendor) {
            return null;
        }

        const payload: IGetProjectsForVendorDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.state.selectedVendor.guid,
        };

        this.props.socket.emit(EndpointsEnum.ProjectsGetProjectsForVendor, payload);
    };

    getProjectsByName = (name: string) => {
        const payload: IGetProjectsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name,
            limit: 20,
        };

        this.props.socket.emit(EndpointsEnum.ProjectsGetProjects, payload);
    };

    onGetProjectsForVendor = (data: IOnGetProjectsForVendorDTO) => {
        this.setState({
            projects: data.projects,
        });
    };

    onGetProjects = (data: IOnGetProjectsDTO) => {
        this.setState({
            foundProjects: data.projects,
        });
    };

    cancel = () => {
        this.props.cancelFn();
    };

    clearTypeaheadCallback = () => {
        this.setState({
            selectedVendor: null,
            hasCatalogLock: false,
            hasPriceGroupLock: false,
            lockedCatalogName: "",
            lockedPriceGroupName: "",
            formValid: false,
        });
    };

    createOrder = async () => {
        const catalog = _.find(this.state.catalogs, (catalog) => {
            return Number(catalog.id) === Number(this.state.catalog);
        });
        const priceGroup = _.find(this.state.priceGroups, (priceGroup) => {
            return Number(priceGroup.id) === Number(this.state.price_group);
        });
        if (!this.state.selectedVendor) {
            return null;
        }

        const payload: ICreateOrderDTO | any = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.state.selectedVendor.guid,
            catalogGuid: _.get(catalog, "guid", undefined),
            priceGroupGuid: _.get(priceGroup, "guid", undefined),
            po_no: this.state.po_no,
            description: this.state.description,
            is_sample: this.state.is_sample,
            is_quote: this.props.isQuote,
            is_template: this.props.isTemplate,
            category_id: this.state.category_id,
            project_id: this.state.project_id,
            template_id: this.state.template_id,
        };

        if (this.state.selectedTags.length) {
            payload.tags = this.state.selectedTags.map((tag) => tag.id);
        }

        if (this.props.isTemplate) {
            payload.is_default_template = this.state.is_default_template;
        }

        if (this.state.exchange_rate) {
            payload.exchange_rate = this.state.exchange_rate;
        }

        if (this.state.shipping_warehouse_id) {
            payload.shipping_warehouse_id = this.state.shipping_warehouse_id;
        }

        if (this.state.order_category_id) {
            payload.category_id = this.state.order_category_id;
        }

        if (this.state.is_local_delivery) {
            payload.is_local_delivery = this.state.is_local_delivery;
        }

        if (this.state.is_local_pickup) {
            payload.is_local_pickup = this.state.is_local_pickup;
        }

        if (this.state.is_dropship) {
            payload.is_dropship = this.state.is_dropship;
        }

        if (this.state.is_consignment) {
            payload.is_consignment = this.state.is_consignment;
        }

        if (this.state.workflow_id) {
            payload.workflow_id = this.state.workflow_id;
        }

        if (this.props.supplierModel.require_order_subs_bo_confirmation) {
            payload.allow_backorders = this.state.allow_backorders;
            payload.allow_substitutions = this.state.allow_substitutions;
        }

        if (this.props.supplierModel.Supplier_Integration.has_qbd && this.state.qbd_ship_via) {
            payload.qbd_ship_via = this.state.qbd_ship_via;
        }

        if (this.props.supplierModel.has_noninventory_orders && this.state.is_noninventory_order) {
            payload.is_noninventory_order = this.state.is_noninventory_order;
        }

        if (this.state.do_not_ship_before_date) {
            payload.do_not_ship_before_date = this.state.do_not_ship_before_date;
        }

        const utm = getCapturedUtm();
        if (utm) {
            payload.utm = utm;
        }

        if (this.state.isOnline) {
            this.props.socket.emit(EndpointsEnum.OrderCreateOrder, payload);

            this.setState({
                createOrderActive: true,
            });
        } else {
            payload["supplierName"] = this.props.supplierModel.name;
            payload["vendorName"] = this.state.selectedVendor.name;

            payload["Catalog"] = catalog;
            payload["catalogName"] = _.get(catalog, "name");
            payload["catalog_id"] = _.get(catalog, "id");

            if (!payload["catalogName"] && this.state.selectedVendor) {
                if (this.state.selectedVendor.Catalog) {
                    payload["catalogName"] = this.state.selectedVendor.Catalog.name;
                    payload["catalog_id"] = this.state.selectedVendor.Catalog.id;
                    payload["Catalog"] = this.state.selectedVendor.Catalog;
                }
            }

            payload["Price_Group"] = priceGroup;
            payload["priceGroupName"] = _.get(priceGroup, "value");
            payload["price_group_id"] = _.get(priceGroup, "id");

            if (!payload["priceGroupName"] && this.state.selectedVendor) {
                if (this.state.selectedVendor.Price_Group) {
                    payload["priceGroupName"] = this.state.selectedVendor.Price_Group.value;
                    payload["price_group_id"] = this.state.selectedVendor.Price_Group.id;
                    payload["Price_Group"] = this.state.selectedVendor.Price_Group;
                }
            }

            payload["Vendor"] = this.state.selectedVendor;

            // payload['Order_Item_Type'] = 'TODO';
            // payload['Order_State'] = 'TODO';

            payload["User"] = this.props.userModel;
            payload["Supplier"] = this.props.supplierModel;
            payload["order_item_type_id"] = this.props.supplierModel.order_item_type_id;
            payload["order_state_id"] = 1;
            payload["Order_Items"] = [];
            payload["items"] = [];
            payload["vendorGuid"] = this.state.selectedVendor.guid;
            payload["details"] = {};

            // TODO - Store the Category Name?

            // save the payload., have 'offline' guid, and load up the order entry page with the offline guid
            const savedPayloadOfflineGuid = await this.idbService.createOrder(payload);
            this.props.cancelFn();

            let url = `/orders/${savedPayloadOfflineGuid}/entry`;

            if (payload.is_quote) {
                url = `/quotes/${savedPayloadOfflineGuid}/entry`;
            }

            this.props.history(url);
        }
    };

    onCreateOrder = (data: IOnCreateOrderDTO) => {
        // console.log(data);
        // this.getOrders();

        let url = `/orders/${data.order!.guid}/entry`;

        if (data.order.is_quote) {
            url = `/quotes/${data.order!.guid}/entry`;
        }

        if (this.props.supplierModel.has_ecommerce_view) {
            if (this.props.supplierModel.ecommerce_default_view) {
                url += `?checkout=false&view=ecom`;
            }
        }

        this.props.history(url);

        this.props.cancelFn();
    };

    findVendorsByName = async (typeahead: string) => {
        if (this.state.isOnline) {
            const encodedTypeahead = encodeURIComponent(typeahead);

            const payload: IGetVendorsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                queryString: `name=${encodedTypeahead}`,
                limit: 20,
                filterInactive: this.state.filterInactive,
            };

            this.props.socket.emit(EndpointsEnum.VendorsGetVendors, payload);
        } else {
            // do a search in the jsstore for the name and set the foundVendors accordingly.
            const foundVendors = await this.idbService.findVendorsByName(typeahead);

            this.setState({
                foundVendors,
            });
        }
    };

    onGetVendors = (data: IOnGetVendorsDTO) => {
        const foundVendors = _.map(data.supplierVendorTokens, (tokenData) => {
            return tokenData.Vendor!;
        });

        this.setState({
            foundVendors,
        });
    };

    onGetPriceGroups = (data: IOnGetPriceGroupsDTO) => {
        this.setState({
            priceGroups: data.priceGroups,
        });
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        this.setState(
            {
                catalogs: data.catalogs,
            },
            () => {
                if (this.props.vendorModel && !this.props.userModel.isSupplierUser) {
                    this.selectedVendor(this.props.vendorModel);
                }
            }
        );
    };

    getPriceGroups = () => {
        const catalog: any = _.find(this.state.catalogs, (catalog) => {
            if (this.state.catalog) {
                return catalog.id === this.state.catalog;
            }
        });

        if (catalog) {
            const payload = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                catalogGuid: catalog.guid,
            };

            this.props.socket.emit(EndpointsEnum.CatalogsGetPriceGroups, payload);
        }
    };

    selectedVendor = (vendor: IVendorModel) => {
        let hasCatalogLock = false;
        let hasPriceGroupLock = false;
        let lockedCatalogName: string | null = null;
        let lockedPriceGroupName: any = null;

        if (!_.isNil(vendor.lock_catalog_id)) {
            hasCatalogLock = true;
            lockedCatalogName = _.get(vendor, "Catalog.name", "");

            const e = {
                target: {
                    type: "select",
                    value: vendor.lock_catalog_id,
                    name: "catalog",
                },
            } as ChangeEvent<any>;

            this.handleChange(e);
        } else {
            if (this.props.userModel.isSupplierUser && !_.isNil(this.props.userModel.supplierUserToken?.catalog_id)) {
                hasCatalogLock = true;
                lockedCatalogName = _.get(this.props.userModel.supplierUserToken, "Catalog.name", "");
            }
        }

        if (!_.isNil(vendor.price_group_id)) {
            hasPriceGroupLock = true;
            lockedPriceGroupName = _.get(vendor, "Price_Group.value", "");
        } else {
            if (this.props.userModel.isSupplierUser && !_.isNil(this.props.userModel.supplierUserToken?.price_group_id)) {
                hasPriceGroupLock = true;
                lockedPriceGroupName = _.get(this.props.userModel.supplierUserToken, "Price_Group.value", "");
            }
        }

        let is_sample: boolean | undefined = undefined;

        if (this.props.supplierModel.has_sample_orders) {
            is_sample = false;

            if (vendor.is_sample_account) {
                is_sample = true;
            }
        }

        const formValid = this.performFormValidation(vendor);

        const order_category_id = vendor.default_order_category_id;

        const is_local_delivery = vendor.default_local_delivery;
        const is_local_pickup = vendor.default_local_pickup;

        let exchange_rate: number | undefined;

        if (vendor.Catalog?.Currency && vendor.Currency) {
            exchange_rate = OrderEntryService.getCurrencyRate(vendor.Catalog?.Currency, vendor.Currency);
        }

        const state: any = {
            foundVendors: null,
            selectedVendor: vendor,
            hasCatalogLock,
            hasPriceGroupLock,
            lockedCatalogName,
            lockedPriceGroupName,
            is_sample,
            formValid,
            order_category_id,
            is_local_delivery,
            is_local_pickup,
            exchange_rate,
        };

        if (vendor.default_workflow_id) {
            state.workflow_id = vendor.default_workflow_id;
        }

        this.setState(state, () => {
            if (this.props.supplierModel.has_templates) {
                this.getTemplatesByAccount();
            }
        });
    };

    performFormValidation = (selectedVendor?: any): boolean => {
        let isFormValid = true;

        if (!this.state.selectedVendor && !selectedVendor) {
            isFormValid = false;
        }

        if (!this.state.template_id) {
            if (!this.state.hasCatalogLock) {
                if (!this.state.catalog) {
                    isFormValid = false;
                }
            }

            if (!this.state.hasPriceGroupLock) {
                if (!this.state.price_group) {
                    if (!this.props.userModel.isSupplierUser && !this.props.supplierModel.hide_vendor_price_group_select) {
                        isFormValid = false;
                    } else {
                        isFormValid = false;
                    }
                }
            }
        }

        if (this.props.supplierModel.order_category_required) {
            if (!this.state.order_category_id) {
                isFormValid = false;
            }
        }

        if (this.props.supplierModel.orders_require_po) {
            if (!this.state.po_no?.trim().length) {
                isFormValid = false;
            }
        } else if (!!selectedVendor?.require_po || this.state.selectedVendor?.require_po) {
            if (!this.state.po_no?.trim().length) {
                isFormValid = false;
            }
        }

        if (this.props.supplierModel.require_order_subs_bo_confirmation) {
            if (_.isNil(this.state.allow_substitutions)) {
                isFormValid = false;
            }

            if (_.isNil(this.state.allow_backorders)) {
                isFormValid = false;
            }
        }

        if (this.props.supplierModel.has_multi_workflows) {
            if (this.props.userModel.isSupplierUser && this.props.userModel.supplierUserToken?.id === UserTypesEnum.ADMIN) {
                if (_.isNil(this.state.workflow_id) || !this.state.workflow_id.toString().length) {
                    isFormValid = false;
                }
            }
        }

        if (this.props.supplierModel.has_warehouses) {
            if (this.props.userModel.isSupplierUser || this.props.supplierModel.allow_accounts_select_warehouse) {
                if (this.props.supplierModel.require_accounts_select_warehouse) {
                    if (_.isNil(this.state.shipping_warehouse_id) || !this.state.shipping_warehouse_id.toString().length) {
                        isFormValid = false;
                    }
                }
            }
        }

        return isFormValid;
    };

    handleQbdShipViaChange = (shipVia: { title: string; value: string }) => {
        const qbdShipVia = (this.props.supplierModel.Supplier_Integration.qbd_ShipMethodOptions || [])
            .filter((item) => item.IsActive)
            .find((item) => item.ListID === shipVia.value);

        this.setState({
            qbd_ship_via: qbdShipVia,
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any | State = this.state;

        state[name] = value;

        // console.log("handleChange", value, name);

        if (name === "catalog" || name === "price_group") {
            if (_.isString(value) && !value.length) {
                state[name] = null;
            }
        }

        if (name === "catalog" && (!value || !value.length)) {
            state.price_group = null;
            state.priceGroups = [];
        }

        this.setState(state, () => {
            // console.log("Catalog State: ", this.state.catalog);

            if (name === "catalog") {
                const catalog = _.find(this.state.catalogs, (catalog) => {
                    // @ts-expect-error
                    return parseInt(catalog.id) === parseInt(value);
                }) as ICatalog;

                if (!catalog) {
                    const formValid = this.performFormValidation();

                    this.setState({
                        formValid,
                    });

                    return;
                }

                let priceGroups = _.get(catalog, "Price_Groups", []);
                priceGroups = _.isNil(priceGroups) ? [] : priceGroups;

                let isValidCategorySelection = true;

                if (catalog.reqd_order_categories) {
                    isValidCategorySelection = false;
                }

                const formValid = this.performFormValidation();

                let price_group = this.state.price_group;

                if (
                    Number(this.state.catalog) === Number(this.props.supplierModel.default_order_catalog_id) &&
                    this.props.supplierModel.default_order_price_group_id
                ) {
                    price_group = this.props.supplierModel.default_order_price_group_id;
                }

                if (
                    !this.props.supplierModel.default_order_price_group_id &&
                    !this.props.userModel.isSupplierUser &&
                    this.props.supplierModel.hide_vendor_price_group_select &&
                    priceGroups.length
                ) {
                    price_group = priceGroups[0].id;
                }

                this.setState({ priceGroups, isValidCategorySelection, formValid, price_group });
            } else {
                const formValid = this.performFormValidation();

                this.setState({
                    formValid,
                });
            }
        });
    };

    validCategorySelection = (isValidCategorySelection: boolean) => {
        this.setState({
            isValidCategorySelection,
        });
    };

    setCategoryId = (id: number) => {
        console.log("setCategoryId", id);
        this.setState({
            category_id: id,
        });
    };

    /**
     * Setup the UI to Require the Necessary Categories, Per the Business Requirements
     */
    getRequiredCatalogCategories = () => {
        const catalogModel: any = _.find(this.state.catalogs, (catalog) => {
            // console.log(`Catalog Id: ${catalog.id} === ${this.state.catalog}`);
            if (Number(catalog.id) === Number(this.state.catalog)) {
                return true;
            }
        });

        if (!this.state.catalog || _.isNil(catalogModel) || (catalogModel && _.isNil(catalogModel.reqd_order_categories))) {
            return null;
        }

        return (
            <div className={"mt-2"}>
                <OwLabel title={"category"} />
                <OrderCategorySelector
                    catalogModel={catalogModel}
                    userModel={this.props.userModel}
                    supplierModel={this.props.supplierModel}
                    socket={this.props.socket}
                    validCategorySelectionFn={this.validCategorySelection}
                    setCategoryId={this.setCategoryId}
                />
            </div>
        );
    };

    showCreateNewVendorModal = () => {
        const component = (
            <VendorSidebar
                socket={this.props.socket}
                userModel={this.props.userModel}
                priceGroups={[]}
                notifyFn={this.props.notifyFn}
                supplierModel={this.props.supplierModel}
                cancel={this.closeModal}
                catalogs={this.state.catalogs}
            />
        );

        this.setState({
            modalComponent: component,
            modalIsOpen: true,
        });
    };

    closeModal = () => {
        this.setState({
            modalIsOpen: false,
            modalComponent: null,
        });
    };

    renderVendorsLine = (item: IVendorModel) => {
        if (item) {
            let hasShipTo = false;

            if (item.Ship_To) {
                if (item.Ship_To.address_line_one || item.Ship_To.city || item.Ship_To.state) {
                    hasShipTo = true;
                }
            }

            return (
                <div>
                    <div>{item.name}</div>
                    {item.ffl_number ? <div className={"text-small text-muted"}>{item.ffl_number}</div> : null}
                    {hasShipTo ? (
                        <div className={"text-small text-muted"}>
                            <div>{item.Ship_To?.address_line_one}</div>
                            <div>
                                {item.Ship_To?.city}, {item.Ship_To?.state}
                            </div>
                        </div>
                    ) : null}
                    {item.customer_internal_id ? <div className={"text-small text-muted"}>{item.customer_internal_id}</div> : null}
                </div>
            );
        } else {
            return null;
        }
    };

    renderTemplateTitleFn = (row: Partial<IOrder>) => {
        let str = `${row.name}`;

        if (row.description?.length) {
            str += ` - ${row.description}`;
        }

        if (row.is_default_template) {
            str += " (Default)";
        }

        return str;
    };

    selectTag = (tag: any) => {
        this.setState({
            selectedTags: [...this.state.selectedTags, tag],
        });
    };

    resetTagTypeaheadCallback = () => {
        this.setState({
            selectedTag: undefined,
            resetTagTypeahead: false,
        });
    };

    removeTag = (tag: ITag) => {
        this.setState({
            selectedTags: this.state.selectedTags.filter((selectedTag) => selectedTag.id !== tag.id),
        });
    };

    handleDoNotShipBeforeDateChange = (date: Moment) => {
        this.setState({
            do_not_ship_before_date: date.format("YYYY-MM-DDT00:00:00Z"),
        });
    };

    getDefaultCreateOrderComponent = () => {
        let showCatalogPriceGroupSelection = true;
        let showCatalogSelection = true;
        let showPriceGroupSelection = true;

        const trueFalseOptions = [
            { value: true, title: "True" },
            { value: false, title: "False" },
        ];

        const qbdShipViaOptions = (this.props.supplierModel.Supplier_Integration.qbd_ShipMethodOptions || [])
            .filter((item) => item.IsActive)
            .map((item) => {
                return {
                    value: item.ListID,
                    title: item.Name,
                };
            });

        if (this.props.userModel.supplierUserToken) {
            const supplierUserToken = this.props.userModel.supplierUserToken;

            if (supplierUserToken.access_type_id === systemConst.accessTypes.RESTRICTED) {
                if (!_.isNil(supplierUserToken.price_group_id) && !_.isNil(supplierUserToken.catalog_id)) {
                    showCatalogPriceGroupSelection = false;
                } else {
                    if (!_.isNil(supplierUserToken.price_group_id)) {
                        showPriceGroupSelection = false;
                    }

                    if (!_.isNil(supplierUserToken.catalog_id)) {
                        showCatalogSelection = false;
                    }
                }
            }
        } else if (this.props.userModel.vendorUserToken) {
            // TODO - Setup for the vendor users options here.

            if (this.props.supplierModel.hide_vendor_price_group_select) {
                showPriceGroupSelection = false;
            }
        }

        // If the user has access to more than one price group AND isn't locked to a single price group
        if (this.props.supplierModel.has_price_group_restrictions) {
            if (this.state.priceGroups) {
                if ((this.state.priceGroups || []).length > 1 && !this.props.vendorModel.price_group_id) {
                    showPriceGroupSelection = true;
                }
            }
        }

        const priceGroups = _.sortBy(this.state.priceGroups, ["value"]);

        let defaultWorkflowId: number | null = null;

        if (this.props.supplierModel.has_multi_workflows) {
            if (this.state.selectedVendor?.default_workflow_id) {
                defaultWorkflowId = this.state.selectedVendor.default_workflow_id;
            } else if (this.props.supplierModel.default_workflow_id) {
                defaultWorkflowId = this.props.supplierModel.default_workflow_id;
            }
        }

        return (
            <form ref={this.formEl}>
                <div className="mb-4">
                    <OwLabel
                        isBold={true}
                        title={"vendor"}
                        supplierModel={this.props.supplierModel}
                        isSupplierVendorOverride={true}
                        showIsReqAsterik={true}
                    />
                    <div className="position-relative">
                        <div className={this.props.userModel.isSupplierUser ? "" : "d-none"}>
                            <Typeahead
                                className=""
                                clearTypeahead={this.state.clearVendorTypeahead}
                                clearTypeaheadCallback={() => {
                                    this.clearTypeaheadCallback();
                                }}
                                typeaheadItems={this.state.foundVendors}
                                titleProp="name"
                                scrollableList={true}
                                subTitleProp="customer_internal_id"
                                itemsRenderFn={this.renderVendorsLine}
                                isRequired={true}
                                maxResults={20}
                                placeholder="Search"
                                selectedItem={this.state.selectedVendor}
                                isSelectableFn={() => {
                                    return true;
                                }}
                                selectedItemFn={this.selectedVendor}
                                typeaheadApiFn={this.findVendorsByName}
                                showCreateNew={
                                    this.props.userModel.isSupplierUser && this.props.supplierModel.allow_create_vendor_in_create_order
                                }
                                createNewFn={this.showCreateNewVendorModal}
                                autoFocus={true}
                            />
                            {this.props.userModel.isSupplierUser &&
                            this.props.userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.ADMIN ? (
                                <div>
                                    <OwCheckbox
                                        label={"filter_inactive"}
                                        fn={this.handleChange}
                                        name={"filterInactive"}
                                        truthyVal={true}
                                        falsyVal={false}
                                        checked={this.state.filterInactive}
                                    />
                                </div>
                            ) : null}
                        </div>
                        <div className={this.props.userModel.isSupplierUser ? "d-none" : ""}>{this.props.vendorModel.name}</div>
                    </div>
                </div>

                {this.props.supplierModel.has_templates && !this.props.isQuote && !this.props.isTemplate ? (
                    <div className={"mb-4"}>
                        <OwLabel title={"template"} noBottomMargin={true} />
                        <div>
                            <OwSelectOption
                                valueProp={"id"}
                                titleProp={"name"}
                                titleRenderFn={this.renderTemplateTitleFn}
                                fn={this.handleChange}
                                name={"template_id"}
                                options={this.state.templates}
                                isDisabled={!this.state.selectedVendor || !this.state.templates.length}
                                showBlankFirst={true}
                            />
                        </div>
                    </div>
                ) : null}

                {this.props.supplierModel.has_projects ? (
                    <div className={"mb-4"}>
                        <OwLabel title={"project"} noBottomMargin={true} />
                        <div>
                            <TypeaheadFn
                                lookupFn={this.getProjectsByName}
                                availableOptions={this.state.foundProjects || []}
                                selectedOption={this.state.selectedProject}
                                selectedOptionFn={(project: IProject) => {
                                    this.setState({
                                        project_id: project.id,
                                        selectedProject: project,
                                    });
                                }}
                                titleProp={"name"}
                                placeholder={"Search projects..."}
                            />
                        </div>
                    </div>
                ) : null}

                <div className={showCatalogPriceGroupSelection ? "mb-4" : "d-none"}>
                    <div className={showCatalogSelection ? "mb-4" : "d-none"}>
                        <OwLabel isBold={true} title={"catalog"} showIsReqAsterik={true} />
                        <div className={this.state.hasCatalogLock ? "d-none" : ""}>
                            {this.state.catalogs.length ? (
                                <OwSelectOption
                                    options={this.state.catalogs}
                                    valueProp={"id"}
                                    titleProp={"name"}
                                    fn={this.handleChange}
                                    name={"catalog"}
                                    isRequired={true}
                                    showBlankFirst={true}
                                    selectedOption={this.props.supplierModel}
                                    selectedOptionProp={"default_order_catalog_id"}
                                    emitOnLoad={true}
                                    emitTarget={true}
                                    isDisabled={!!this.state.template_id}
                                />
                            ) : null}

                            {this.getRequiredCatalogCategories()}
                        </div>
                        <div className={this.state.hasCatalogLock ? "" : "d-none"}>{this.state.lockedCatalogName}</div>
                    </div>

                    <div className={showPriceGroupSelection ? "mb-4" : "d-none"}>
                        <OwLabel isBold={true} title={"price_group"} showIsReqAsterik={true} />
                        <div className={this.state.hasPriceGroupLock ? "d-none" : ""}>
                            {this.state.priceGroups.length ? (
                                <OwSelectOption
                                    options={priceGroups}
                                    selectedOption={this.state}
                                    selectedOptionProp={"price_group"}
                                    valueProp={"id"}
                                    titleProp={"value"}
                                    fn={this.handleChange}
                                    name={"price_group"}
                                    isRequired={true}
                                    showBlankFirst={true}
                                    isDisabled={!!this.state.template_id}
                                />
                            ) : null}
                        </div>
                        <div className={this.state.hasPriceGroupLock ? "" : "d-none"}>{this.state.lockedPriceGroupName}</div>
                    </div>
                </div>

                {this.props.supplierModel.has_do_not_ship_before_date ? (
                    <div className={"mt-3"}>
                        <OwLabel title={"do_not_ship_before_date"} isBold={true} showIsReqAsterik={true} />
                        <div>
                            <OwDateInput selectedDate={this.state.do_not_ship_before_date} fn={this.handleDoNotShipBeforeDateChange} />
                        </div>
                    </div>
                ) : null}

                {this.props.supplierModel.has_local_delivery ? (
                    <div className={"mt-3"}>
                        <OwCheckbox
                            label={"is_local_delivery"}
                            fn={this.handleChange}
                            name={"is_local_delivery"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={this.state.is_local_delivery}
                            disabled={this.state.is_local_pickup || this.state.is_dropship}
                        />
                    </div>
                ) : null}

                {this.props.supplierModel.has_local_pickup ? (
                    <div className={"mt-3 mb-3"}>
                        <OwCheckbox
                            label={"is_local_pickup"}
                            fn={this.handleChange}
                            name={"is_local_pickup"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={this.state.is_local_pickup}
                            disabled={this.state.is_local_delivery || this.state.is_dropship}
                        />
                    </div>
                ) : null}

                {this.props.supplierModel.has_dropshipping ? (
                    <div className={"mt-3 mb-3"}>
                        <OwCheckbox
                            label={"is_dropship"}
                            fn={this.handleChange}
                            name={"is_dropship"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={this.state.is_dropship}
                            disabled={this.state.is_local_delivery || this.state.is_local_pickup}
                        />
                    </div>
                ) : null}

                {this.props.supplierModel.has_consignment ? (
                    <div className={"mt-3 mb-3"}>
                        <OwCheckbox
                            label={"is_consignment"}
                            fn={this.handleChange}
                            name={"is_consignment"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={this.state.is_consignment}
                        />
                    </div>
                ) : null}

                {this.props.supplierModel.has_order_categories ? (
                    <div className={"mb-4"}>
                        <OwLabel
                            title={"order_category"}
                            showIsReqAsterik={this.props.supplierModel.order_category_required}
                            isBold={true}
                        />
                        <div>
                            <OwSelectOption
                                options={this.state.orderCategories}
                                selectedOption={this.state}
                                selectedOptionProp={"order_category_id"}
                                valueProp={"id"}
                                titleProp={"name"}
                                fn={this.handleChange}
                                name={"order_category_id"}
                                isRequired={this.props.supplierModel.order_category_required}
                                isActive={this.state.orderCategoryActive}
                                isDisabledOnActive={true}
                                showBlankFirst={true}
                            />
                        </div>
                    </div>
                ) : null}

                {this.props.supplierModel.has_noninventory_orders &&
                this.props.userModel.isSupplierUser &&
                this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN ? (
                    <div className="mb-4">
                        <OwCheckbox
                            fn={this.handleChange}
                            checked={this.state.is_noninventory_order}
                            name={"is_noninventory_order"}
                            falsyVal={false}
                            truthyVal={true}
                            label={"non_inventory_order"}
                        />
                    </div>
                ) : null}

                {this.props.isTemplate ? (
                    <div className="mb-4">
                        <OwCheckbox
                            fn={this.handleChange}
                            checked={this.state.is_default_template}
                            name={"is_default_template"}
                            falsyVal={false}
                            truthyVal={true}
                            label={"is_default_template"}
                        />
                    </div>
                ) : null}

                {this.props.supplierModel.has_warehouses &&
                (this.props.userModel.isSupplierUser || this.props.supplierModel.allow_accounts_select_warehouse) ? (
                    <div className={"mb-4"}>
                        <OwLabel
                            title={"shipping_warehouse"}
                            isBold={true}
                            showIsReqAsterik={!!this.props.supplierModel.require_accounts_select_warehouse}
                        />
                        <div>
                            {this.state.selectedVendor ? (
                                <OwSelectOption
                                    options={
                                        this.state.selectedVendor.Warehouses?.length
                                            ? this.state.selectedVendor.Warehouses
                                            : this.state.warehouses
                                    }
                                    selectedOption={this.state}
                                    selectedOptionProp={"shipping_warehouse_id"}
                                    valueProp={"id"}
                                    titleProp={"name"}
                                    fn={this.handleChange}
                                    name={"shipping_warehouse_id"}
                                    isDisabledOnActive={true}
                                    showBlankFirst={true}
                                    isRequired={!!this.props.supplierModel.require_accounts_select_warehouse}
                                />
                            ) : null}
                        </div>
                    </div>
                ) : null}

                {this.props.supplierModel.Supplier_Integration.has_qbd &&
                this.props.supplierModel.Supplier_Integration.qbd_show_ship_via_options ? (
                    <div className={"mb-4"}>
                        <OwLabel
                            title={"ship_via"}
                            isBold={true}
                            showIsReqAsterik={!!this.props.supplierModel.require_accounts_select_warehouse}
                        />
                        <div>
                            <OwSelectOption
                                fn={this.handleQbdShipViaChange}
                                name={"qbd_ship_via"}
                                titleProp={"title"}
                                valueProp={"value"}
                                options={qbdShipViaOptions}
                                emitObject={true}
                            />
                        </div>
                    </div>
                ) : null}

                <div className={"mb-3"}>
                    <OwLabel
                        isBold={true}
                        title={"po_no"}
                        showIsReqAsterik={!!this.props.supplierModel.orders_require_po || !!this.state.selectedVendor?.require_po}
                    />
                    <div>
                        <OwInputWrapper
                            value={this.state.po_no}
                            fn={this.handleChange}
                            name={"po_no"}
                            isRequired={!!this.props.supplierModel.orders_require_po || !!this.state.selectedVendor?.require_po}
                        />
                    </div>
                </div>

                <div className={"mb-3"}>
                    <OwLabel isBold={true} title={"description"} />
                    <div>
                        <OwInputWrapper value={this.state.description} fn={this.handleChange} name={"description"} />
                    </div>
                </div>

                {this.props.supplierModel.has_currencies &&
                this.state.selectedVendor?.Currency &&
                (this.state.selectedCatalog?.currency_id || this.state.selectedVendor?.Catalog?.currency_id) ? (
                    <div className={"mb-3"}>
                        <OwLabel isBold={true} title={"exchange_rate"} />
                        <OwInputWrapper name={"exchange_rate"} value={this.state.exchange_rate} fn={this.handleChange} />
                    </div>
                ) : null}

                <div
                    className={
                        "mb-3 " +
                        (this.props.supplierModel.has_sample_orders &&
                        this.props.userModel.isSupplierUser &&
                        this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN
                            ? ""
                            : "d-none")
                    }>
                    <div>
                        <OwCheckbox label={"is_sample"} name={"is_sample"} fn={this.handleChange} checked={this.state.is_sample} /> ?
                    </div>
                </div>

                {this.props.supplierModel.require_order_subs_bo_confirmation ? (
                    <div>
                        <div>
                            <div>
                                <OwLabel title={"allow_backorders"} isBold={true} showIsReqAsterik={true} />
                                <OwSelectOption
                                    options={trueFalseOptions}
                                    fn={this.handleChange}
                                    name={"allow_backorders"}
                                    titleProp={"title"}
                                    valueProp={"value"}
                                    isRequired={true}
                                />
                            </div>
                            <div className={"mt-3 mb-3"}>
                                <OwLabel title={"allow_substitutions"} isBold={true} showIsReqAsterik={true} />
                                <OwSelectOption
                                    options={trueFalseOptions}
                                    fn={this.handleChange}
                                    name={"allow_substitutions"}
                                    titleProp={"title"}
                                    valueProp={"value"}
                                    isRequired={true}
                                />
                            </div>
                        </div>
                    </div>
                ) : null}

                {this.props.supplierModel.has_multi_workflows &&
                this.props.userModel.isSupplierUser &&
                (this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN ||
                    this.props.supplierModel.allow_non_admin_select_workflow) ? (
                    <div>
                        <div className={"mt-3 mb-3"}>
                            <OwLabel title={"workflow"} isBold={true} showIsReqAsterik={true} />
                            <OwSelectOption
                                options={this.state.workflowOptions}
                                fn={this.handleChange}
                                name={"workflow_id"}
                                titleProp={"name"}
                                valueProp={"id"}
                                isRequired={true}
                                selectedOption={defaultWorkflowId}
                                hasSelectedOptionProp={false}
                            />
                        </div>
                    </div>
                ) : null}

                {this.props.userModel.isSupplierUser ? (
                    <div className={"mt-3 mb-3"}>
                        <OwLabel title={"tags"} isBold={true} />
                        <div>
                            <Typeahead
                                typeaheadApiFn={this.getTags}
                                typeaheadItems={this.state.foundTags}
                                selectedItemFn={this.selectTag}
                                selectedItem={this.state.selectedTag}
                                titleProp={"name"}
                                clearTypeaheadCallback={this.resetTagTypeaheadCallback}
                                clearTypeahead={this.state.resetTagTypeahead}
                                isSelectableFn={() => true}
                                confirmAdd={true}
                                showCreateNew={true}
                                createNewFn={this.processTag}
                            />
                        </div>

                        <div>
                            {this.state.selectedTags.map((tag) => {
                                return (
                                    <span key={tag.guid} className={"badge bg-primary"}>
                                        {tag.name}
                                        <i
                                            className={"fas fa-times pointer ms-2"}
                                            onClick={() => {
                                                this.removeTag(tag);
                                            }}
                                        />
                                    </span>
                                );
                            })}
                        </div>
                    </div>
                ) : null}

                <div>
                    <OwButton
                        id={"create_order"}
                        title={"create"}
                        fn={this.createOrder}
                        active={this.state.createOrderActive}
                        disabled={!this.state.formValid || this.state.createOrderActive}
                        disableOnActive={true}
                    />
                </div>
            </form>
        );
    };

    getCustomCreateOrder = (): any => {
        let customCreateOrderComponent: any = null;

        switch (this.props.supplierModel.create_order_component) {
            default:
                customCreateOrderComponent = null;
                break;
        }

        return customCreateOrderComponent;
    };

    render() {
        let title = "create_order";
        let leftIconName = "far fa-list-alt";

        if (this.props.isQuote) {
            title = "create_quote";
            leftIconName = "fa fa-file-alt";
        }

        if (this.props.isTemplate) {
            title = "create_template";
            leftIconName = "fa fa-file-alt";
        }

        if (!this.state.isOnline) {
            title = "create_offline_order";
        }

        return (
            <div className="CreateOrderSidebar p-2">
                <div className={"col-12"}>
                    <div className="text-end">
                        <button className="btn btn-danger btn-sm" onClick={this.cancel}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} leftIconName={leftIconName} title={title} />
                    <hr />
                </div>

                <div className={"col-12"}>
                    {this.props.supplierModel.create_order_component ? this.getCustomCreateOrder() : this.getDefaultCreateOrderComponent()}
                </div>

                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={(e: any) => {
                        this.closeModal();
                    }}
                    contentLabel="Orderwerks"
                    shouldCloseOnOverlayClick={false}
                    className={"modalContentClass"}
                    overlayClassName={"modalOverlayClass"}
                    style={{}}>
                    {this.state.modalComponent}
                </Modal>
            </div>
        );
    }
}

export default CreateOrderSidebar;
